module.exports = "pegasus_template/assets/themecapture1/small/bg1.png";